import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setQrCode } from "../redux/slices/qrSlice";

const Language = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { code } = useParams();

  const [selectedLang, setSelectedLang] = useState("en");

  const languages = [
    { label: "English", value: "en" },
    { label: "Hindi - हिन्दी", value: "hi" },
    { label: "Punjabi - ਪੰਜਾਬੀ", value: "pa" },
    { label: "Marathi - मराठी", value: "mr" },
    { label: "Gujarati - ગુજરાતી", value: "gu" },
    { label: "Kannada - ಕನ್ನಡ", value: "kn" },
    { label: "Telugu - తెలుగు", value: "te" },
    { label: "Tamil - தமிழ்", value: "ta" },
  ];

  useEffect(() => {
    const savedLang = localStorage.getItem("appLanguage");
    if (savedLang) setSelectedLang(savedLang);
  }, []);

  useEffect(() => {
    if (code) {
      dispatch(setQrCode(code));
      localStorage.setItem("qrCode", code);
    }
  }, [code, dispatch]);

  const handleContinue = () => {
    localStorage.setItem("appLanguage", selectedLang);
    navigate("/login");
  };

  return (
    <div
      className="min-h-screen flex justify-center"
      style={{
        fontFamily: "'Poppins', sans-serif",
        backgroundColor: '#f0f4f0',
        backgroundImage: 'radial-gradient(circle, #c8d8c8 1px, transparent 1px)',
        backgroundSize: '22px 22px',
      }}
    >
      <div className="w-full max-w-md min-h-screen flex flex-col">

        {/* Top Bar */}
        <div className="flex justify-between items-center px-6 pt-5 pb-2">
          <img src="/logo.png" alt="Gencrest" className="h-8 w-auto object-contain" />
          <div
            className="text-[15px] font-extrabold text-[#1a2e1a] tracking-tight"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            AgroSatva
          </div>
        </div>

        <div className="px-4 pt-2 pb-8 flex flex-col gap-4 flex-1">

          {/* Banner */}
          <div className="rounded-2xl overflow-hidden shadow-sm">
            <img
              src="/banner.jpg"
              alt="banner"
              className="w-full object-cover"
            />
          </div>

          {/* Language card */}
          <div className="bg-white rounded-2xl shadow-sm mx-1 flex flex-col overflow-hidden">

            {/* Card Content */}
            <div className="px-5 py-6">
              <h1 className="text-[20px] font-bold text-[#1a2e1a] mb-1">
                Select Language
              </h1>
              <p className="text-[12px] text-gray-400 mb-5">
                Choose your preferred language to continue
              </p>

              {/* Language grid */}
              <div className="grid grid-cols-2 gap-2 mb-5">
                {languages.map((lang) => (
                  <button
                    key={lang.value}
                    onClick={() => setSelectedLang(lang.value)}
                    className={`py-3 px-3 rounded-xl text-[13px] font-semibold text-left transition-all active:scale-[0.97] border-[1.5px] ${selectedLang === lang.value
                      ? 'border-[#2d5a2d] bg-[#2d5a2d] text-white'
                      : 'border-[#e0e8e0] bg-[#f8faf8] text-[#1a2e1a]'
                      }`}
                  >
                    {lang.label}
                  </button>
                ))}
              </div>

              {/* Continue button */}
              <button
                onClick={handleContinue}
                className="w-full py-3.5 rounded-xl text-[15px] font-bold text-white flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
                style={{ backgroundColor: '#2d5a2d' }}
              >
                Continue
              </button>
            </div>

         

          </div>


        </div>
 <div className="w-full py-3 border-t border-gray-200 mt-auto">
        <p className="text-[13px] text-black uppercase text-center tracking-wide">
          © {new Date().getFullYear()} Gencrest
        </p>
      </div>
      </div>

    </div>
  );
};

export default Language;